import { render, staticRenderFns } from "./OrderChangeStatusDialog.vue?vue&type=template&id=4467dec2&"
import script from "./OrderChangeStatusDialog.vue?vue&type=script&lang=js&"
export * from "./OrderChangeStatusDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports